import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { intlShape, injectIntl } from 'react-intl';
import randomstring from 'uuid/v4';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/api.reports.search.actions';
import * as actionsHome from '../../../../actions/process.home.actions';

import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';

import Search from '@material-ui/icons/Search';
import Dialog from './DialogFields';

import Snackbar from '../../../labels/Snackbar';
import BlueButton from '../../../buttons/BlueButton';

const getItems = (array, field) => {
    return array.reduce((arr, f) => {
        if (f.codigo === field || (!f.codigo && f.nombre === field)) {
            arr = f.hijos.map((i) => {
                return {
                    nombre: i.nombre.toUpperCase(),
                    codigo: i.codigo,
                    hijos: i.hijos,
                    tipo: i.tipo,
                };
            });
        } else if (f.hijos && f.hijos.length > 0) {
            arr = arr.concat(getItems(f.hijos, field));
        }
        return arr;
    }, []);
};

const getItem = (array, field) => {
    return array.reduce((item, f) => {
        if (f.codigo === field || (!f.codigo && f.nombre === field)) {
            item = f;
        } else if (f.hijos && f.hijos.length > 0) {
            const aux = getItem(f.hijos, field);
            if (aux !== undefined) {
                item = aux;
            }
        }
        return item;
    }, undefined);
};

class MenuValue extends React.Component {
    state = {
        report_search_is_fields: undefined,
    };

    static getDerivedStateFromProps(props, state) {
        const { report_search_is_fields, report_search_is_values, info } = props;
        console.log(report_search_is_fields, report_search_is_values);
        if (
            report_search_is_fields !== state.report_search_is_fields ||
            report_search_is_values !== state.report_search_is_values
        ) {
            state.report_search_is_fields = report_search_is_fields;
            state.report_search_is_values = report_search_is_values;

            state.index = 0;
            state.family = report_search_is_values.family;
            state.process = report_search_is_values.process;
            state.field = report_search_is_values.field
                ? {
                    label: report_search_is_values.fieldLabel,
                    value: report_search_is_values.field,
                }
                : undefined;
            state.value = report_search_is_values.value;
            state.local = report_search_is_values.local;
            state.from = report_search_is_values.from;
            state.to = report_search_is_values.to;
            state.minimun =
                report_search_is_values.range && report_search_is_values.range.inferior
                    ? report_search_is_values.range.inferior
                    : '';
            state.minimunlimit =
                report_search_is_values.range && report_search_is_values.range.limiteinferior
                    ? report_search_is_values.range.limiteinferior
                    : false;
            state.maximun =
                report_search_is_values.range && report_search_is_values.range.superior
                    ? report_search_is_values.range.superior
                    : '';
            state.maximunlimit =
                report_search_is_values.range && report_search_is_values.range.limitesuperior
                    ? report_search_is_values.range.limitesuperior
                    : false;
            state.nodes =
                info.security.locals && info.security.locals.length > 0
                    ? info.security.locals.reduce((arr, c) => {
                        if (
                            info.security.localPermits[c.id] &&
                            info.security.localPermits[c.id].length > 0
                        ) {
                            arr.push(c);
                        }
                        return arr;
                    }, [])
                    : [];
            state.families =
                report_search_is_fields && report_search_is_fields.length > 0
                    ? report_search_is_fields.reduce((arr, f) => {
                        if (arr.indexOf(f.nombre) < 0)
                            arr.push({ codigo: f.nombre, nombre: f.nombre.toUpperCase() });
                        return arr;
                    }, [])
                    : [];
            state.processes = report_search_is_values.family
                ? getItems(report_search_is_fields, report_search_is_values.family)
                : [];
            state.fields = report_search_is_values.process
                ? getItems(report_search_is_fields, report_search_is_values.process)
                : undefined;
            state.field = report_search_is_values.field
                ? getItem(report_search_is_fields, report_search_is_values.field)
                : undefined;

            return state;
        }
        return null;
    }

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    handleSearch = (event) => {
        const { intl } = this.props;
        const { family, process, local, field, value, from, to, minimun, maximun } = this.state;
        if (field) {
            const equivalences =
                field.tipo === 'SINO'
                    ? [
                        {
                            reference: 'false',
                            value: intl.formatMessage({ id: 'type_label_boolean_no' }),
                        },
                        {
                            reference: 'true',
                            value: intl.formatMessage({ id: 'type_label_boolean_yes' }),
                        },
                    ]
                    : undefined;
            this.props
                .loadValues(
                    from,
                    to,
                    local,
                    family,
                    process,
                    field.codigo,
                    field.nombre,
                    value,
                    minimun,
                    maximun,
                    equivalences,
                )
                .then(() => this.props.history.push('/reports/search/result'))
                .catch((error) => {
                    this.setState({ error: error.message, errorType: error.type });
                });
        }
    };

    handleChangeFamily = (event) => {
        const { report_search_is_fields } = this.props;
        const processes = event.target.value
            ? getItems(report_search_is_fields, event.target.value)
            : [];

        this.setState({
            [event.target.name]: event.target.value,
            processes: processes,
            field: undefined,
        });
    };

    handleChangeProcess = (event) => {
        const { report_search_is_fields } = this.props;
        const fields = event.target.value
            ? getItems(report_search_is_fields, event.target.value)
            : [];
        this.setState({
            [event.target.name]: event.target.value,
            fields: fields,
            field: undefined,
        });
    };

    handleChangeField = (field) => {
        if (field) {
            this.setState({ field: field, open: false });
        } else {
            this.setState({ open: false });
        }
    };

    handleSearchField = () => {
        this.setState({ open: true });
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleCloseError = () => {
        this.setState({ error: '' });
    };

    handleChangeRange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    render() {
        const {
            family,
            process,
            local,
            field,
            value,
            from,
            to,
            error,
            errorType,
            nodes,
            families,
            processes,
            fields,
            minimun,
            maximun,
            open,
        } = this.state;
        const { intl } = this.props;

        return (
            <div className={'width50 padding_bottom_9'}>
                <div className="padding_borders_flat">
                    <div className="flex_full_row align_center margin_bottom_12">
                        <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                            <InputLabel htmlFor="age-native-simple">
                                {intl.formatMessage({ id: 'type_label_local' })}
                            </InputLabel>
                            <Select
                                native
                                value={local}
                                onChange={this.handleChange}
                                inputProps={{ name: 'local', id: 'local-id' }}
                            >
                                <option key={randomstring()} value={undefined} />
                                {nodes &&
                                    nodes
                                        .sort((a, b) => (a.nombre < b.nombre ? -1 : 1))
                                        .map((cat) => {
                                            return (
                                                <option key={randomstring()} value={cat.id}>
                                                    {cat.name}
                                                </option>
                                            );
                                        })}
                            </Select>
                        </FormControl>
                    </div>
                    <div className="flex_full_row align_center margin_bottom_12">
                        <TextField
                            fullWidth
                            name={'from'}
                            id={'from-date'}
                            label={intl.formatMessage({ id: 'form_field_add_date_init_label' })}
                            type="date"
                            defaultValue={from}
                            onChange={this.handleChange}
                            InputLabelProps={{ shrink: true }}
                        />
                    </div>
                    <div className="flex_full_row align_center margin_bottom_12">
                        <TextField
                            fullWidth
                            name={'to'}
                            id={'to-date'}
                            label={intl.formatMessage({ id: 'form_field_add_date_end_label' })}
                            type="date"
                            defaultValue={to}
                            onChange={this.handleChange}
                            InputLabelProps={{ shrink: true }}
                        />
                    </div>
                    <div className="flex_full_row align_center margin_bottom_12">
                        <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                            <InputLabel htmlFor="age-native-simple">
                                {intl.formatMessage({ id: 'family' })}
                            </InputLabel>
                            <Select
                                required
                                native
                                value={family}
                                name={'family'}
                                onChange={this.handleChangeFamily}
                                inputProps={{ name: 'family', id: 'family-id' }}
                            >
                                <option key={randomstring()} value={undefined} />
                                {families &&
                                    families
                                        .sort((a, b) => (a.nombre < b.nombre ? -1 : 1))
                                        .map((f) => {
                                            return (
                                                <option key={randomstring()} value={f.codigo}>
                                                    {f.nombre}
                                                </option>
                                            );
                                        })}
                            </Select>
                        </FormControl>
                    </div>
                    <div className="flex_full_row align_center margin_bottom_12">
                        <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                            <InputLabel htmlFor="age-native-simple">
                                {intl.formatMessage({ id: 'process' })}
                            </InputLabel>
                            <Select
                                required
                                native
                                value={process}
                                onChange={this.handleChangeProcess}
                                inputProps={{ name: 'process', id: 'process-id' }}
                            >
                                <option key={randomstring()} value={undefined} />
                                {processes &&
                                    processes
                                        .sort((a, b) => (a.nombre < b.nombre ? -1 : 1))
                                        .map((f) => {
                                            return (
                                                <option key={randomstring()} value={f.codigo}>
                                                    {f.nombre}
                                                </option>
                                            );
                                        })}
                            </Select>
                        </FormControl>
                    </div>
                    {process && (
                        <div className="flex_full_column align_center margin_bottom_12 shadow_down_only">
                            <div className="flex_full width100 margin_bottom_6">
                                {field && (
                                    <div className="flex_full width100 barlow_italic_medium c_disabled padding_bottom_6">
                                        {' '}
                                        {intl.formatMessage({ id: 'field' })}{' '}
                                    </div>
                                )}
                            </div>
                            <div className="flex_full width100 margin_bottom_6">
                                <div className={'flex_full_row width100 align_baseline'}>
                                    {field && (
                                        <div className="flex_full width100 barlow_italic c_slate padding_bottom_6">
                                            {' '}
                                            {field.nombre.toUpperCase()}{' '}
                                        </div>
                                    )}
                                    {process && !field && (
                                        <div className="flex_full width100 barlow_italic c_disabled padding_bottom_6">
                                            {' '}
                                            {intl.formatMessage({ id: 'field' })}{' '}
                                        </div>
                                    )}
                                    <div className="flex_auto_row">
                                        {fields && (
                                            <Search
                                                className="c_bluish hand"
                                                onClick={this.handleSearchField}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="flex_full_row align_center margin_bottom_12">
                        {field && field.tipo === 'SINO' && (
                            <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                                <InputLabel htmlFor="age-native-simple">
                                    {intl.formatMessage({ id: 'value' })}
                                </InputLabel>
                                <Select
                                    native
                                    value={value}
                                    onChange={this.handleChange}
                                    inputProps={{ name: 'value', id: 'value-id' }}
                                >
                                    <option key={randomstring()} value={undefined} />
                                    <option key={randomstring()} value={false}>
                                        {intl.formatMessage({
                                            id: 'type_label_boolean_no',
                                        })}
                                    </option>
                                    <option key={randomstring()} value={true}>
                                        {intl.formatMessage({
                                            id: 'type_label_boolean_yes',
                                        })}
                                    </option>
                                </Select>
                            </FormControl>
                        )}
                        {field && (field.tipo === 'ENTERO' || field.tipo === 'REAL') && (
                            <div className={'flex_full_column align_center margin_top_12'}>
                                <div className={'flex_full_row center'}>
                                    <TextField
                                        name="maximun"
                                        label={intl.formatMessage({
                                            id: 'form_field_warningable_less_equal_than',
                                        })}
                                        className={'margin_top_0 flex_full_row'}
                                        value={maximun}
                                        onChange={this.handleChangeRange}
                                        margin="normal"
                                    />
                                    <TextField
                                        name="minimun"
                                        label={intl.formatMessage({
                                            id: 'form_field_warningable_greater_equal_than',
                                        })}
                                        className={'margin_left_12 margin_top_0 flex_full_row'}
                                        value={minimun}
                                        onChange={this.handleChangeRange}
                                        margin="normal"
                                        error={
                                            maximun !== undefined &&
                                            minimun !== undefined &&
                                            parseInt(maximun, 10) < parseInt(minimun, 10)
                                        }
                                        helperText={
                                            maximun &&
                                                minimun &&
                                                parseInt(maximun, 10) < parseInt(minimun, 10)
                                                ? intl.formatMessage({ id: 'error_range' })
                                                : ''
                                        }
                                    />
                                </div>
                            </div>
                        )}
                        {field &&
                            field.tipo !== 'ENTERO' &&
                            field.tipo !== 'REAL' &&
                            field.tipo !== 'SINO' && (
                                <TextField
                                    required
                                    fullWidth
                                    name={'value'}
                                    id={'value'}
                                    defaultValue={value}
                                    label={intl.formatMessage({ id: 'value' })}
                                    onChange={this.handleChange}
                                />
                            )}
                    </div>
                    <div className="flex_full_row align_center" />
                    <BlueButton noValid={!field} id="search" onClick={this.handleSearch} />
                    <div />
                </div>
                {open && <Dialog fields={fields} onClose={this.handleChangeField} />}
                {error && (
                    <Snackbar
                        open={true}
                        variant={errorType ? errorType : "error"}
                        text={error}
                        onClose={this.handleCloseError.bind(this)}
                    />
                )}
            </div>
        );
    }
}

MenuValue.propTypes = {
    intl: intlShape.isRequired,
    report_search_is_fields: PropTypes.array.isRequired,
    report_search_is_values: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        report_search_is_fields: state.report_search_is_fields,
        report_search_is_values: state.report_search_is_values,
        info: state.info,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, actionsHome), dispatch);
};

MenuValue = connect(
    mapStateToProps,
    mapDispatchToProps,
)(MenuValue);

MenuValue = injectIntl(MenuValue);

MenuValue = withRouter(MenuValue);

export default MenuValue;



// WEBPACK FOOTER //
// ./src/components/complex/reports/search/Menu.js